<template>
    <div>
        <div class="row mt-3" v-if="loading">
            <div class="col-12">
				<loader/>
            </div>
        </div>

        <div class="row" v-else-if="submissions && submissions.length">
            <div class="col-12">
                <h4>This week: <small>{{start_of_week}}</small></h4>
            </div>
            <div class="col-12">
                <h5 class="text-danger" v-if="unresolved.length">{{unresolved.length}} Unresolved</h5>
                <h5 class="text-dark" v-else>No unresolved issues</h5>
            </div>
            <div v-if="unresolved.length" class="col-12">
                <div class="flex-table">
                    <list-item
                        v-for="submission in unresolved"
                        :key="submission.id"
                        @click="showSubmission(submission)"
                    >
                        <template slot="title">
                            <div>
                                <h6 class="text-dark mb-0">{{submission.instance.name}}</h6>
								<h6 v-bind:class="submission.form_status.class">{{submission.form_status.title_line_2}}</h6>
                                <div>{{submission.submitted_difference}}</div>
                            </div>
                        </template>

                        <template slot="center">
                            <div class="badge badge--sm badge--secondary">{{submission.user.full_name}}</div>
                        </template>
                    </list-item>
                </div>
            </div>

            <div class="col-12 mt-5">
                <h5 class="text-dark" v-if="resolved.length">{{resolved.length}} Resolved</h5>
                <h5 class="text-dark" v-else>No resolved issues</h5>
            </div>
            <div v-if="resolved.length" class="col-12">
                <div class="flex-table">
                    <list-item
                        v-for="submission in resolved"
                        :key="submission.id"
                        @click="showSubmission(submission)"
                    >
                        <template slot="title">
                            <div class="">
                                <h6 class="text-dark mb-0">{{submission.instance.name}}</h6>
								<h6 v-bind:class="submission.form_status.class">{{submission.form_status.title_line_2}}</h6>
								<div class="">{{submission.submitted_difference}}</div>
                            </div>
                        </template>

                        <template slot="center">
                            <div class="badge badge--sm badge--secondary">{{submission.user.full_name}}</div>
                        </template>
                    </list-item>
                </div>
            </div>
        </div>
        <div class="form-submission-card" v-else>
            <div class="mt-2 form-submission-card-content">
                <h5>No activity this week</h5>
            </div>
        </div>
    </div>
</template>

<script>
	import ListItem from "../ListComponent/ListItem";
	import Loader from "../general_components/Loader";
    export default {
		name: "JobThisWeekComponent",
        components: {Loader, ListItem},
        props: [
        	'load_url',
            'show_submission_url',
            'back_url'
        ],

        data(){
			return {
				loading: false,
                submissions: [],
            }
        },

        mounted(){
			this.load();
        },

        methods: {
			load(){
				let _this = this;
				if (_this.loading){
					return;
                }

				_this.loading = true;

				axios.get(_this.load_url)
                    .then(function (response){
                    	_this.submissions = response.data;
                    	_this.loading = false;
                    });
            },

			showSubmission(submission){
				window.location.href = this.show_submission_url.replace('?', submission.id) + '?back_url=' + this.back_url;
			},
        },

        computed: {
			unresolved(){
				let _subs = [];
				this.submissions.forEach(function (submission){
					if(submission.status === 'unresolved' && submission.type !== 'site_survey_inspection_report' && submission.type !== 'face_fit_test'){
						_subs.push(submission);
                    }
                });
                return _subs.sort((a, b) => {
					return Date.parse(a.submitted_at) > Date.parse(b.submitted_at) ? 1 : -1;
				});
            },

            resolved(){
				let _subs = [];
				this.submissions.forEach(function (submission){
					if(submission.status !== 'unresolved' || submission.type === 'site_survey_inspection_report' || submission.type === 'face_fit_test'){
						_subs.push(submission);
					}
				});
				return _subs;
            },

			start_of_week(){
				let
                    d = new Date(),
                    day = d.getDay(),
                    diff = d.getDate() - day + (day === 0 ? - 6 : 1),
                    monday = new Date(d.setDate(diff));

				return 'Mon, ' + moment(monday).format('MMMM Do YYYY');
            }
        }
	}
</script>
